import type { CardState } from "./pushCard";
import { localStore } from "./localStore";

/** Home's notifications row (the home-and-customers round, 2026-11-03, part four): a quiet invitation at the end of "Needs you" to turn on
 *  notifications on this device. Never a need (no number, never counted). It shows where turning them on is possible and still undone ("off",
 *  or "homeScreen" on an iPad in a browser tab, which the Device tab walks through), for someone present, on a computer or a tablet, who has not
 *  dismissed it. The dismissal lives in this browser per workspace (read and written wrapped, as `pushHint.ts`: a private window only forgets);
 *  Turn off and removing this device in Settings forget it, since that is a new decision. */
export const NOTIFY_ROW = { title: "Turn on notifications on this device", href: "/settings/notifications?tab=device" } as const;

/** `phone`: the phone layout or an iPhone (an iPhone held sideways is wider than the phone layout) */
export type NotifyRowFacts = { state: CardState; away: boolean; phone: boolean; dismissed: boolean };
export const notifyRowShown = (f: NotifyRowFacts): boolean => (f.state === "off" || f.state === "homeScreen") && !f.away && !f.phone && !f.dismissed;

const KEY = "ob-notify-row:";
const pick = localStore;

export function notifyRowDismissed(slug: string, storage?: Storage | null): boolean {
  try { return pick(storage)?.getItem(KEY + slug) != null; } catch { return false; }
}
export function dismissNotifyRow(slug: string, storage?: Storage | null): void {
  try { pick(storage)?.setItem(KEY + slug, new Date().toISOString()); } catch { /* a private window: the row may come back */ }
}
export function forgetNotifyRowDismissal(slug: string, storage?: Storage | null): void {
  try { pick(storage)?.removeItem(KEY + slug); } catch { /* nothing to forget */ }
}
